module.exports = __webpack_public_path__ + "img/plus.3c6de69a.svg";